import { Controller } from "@hotwired/stimulus";
import { i18n } from "../lib/i18n";

export default class extends Controller {
  static targets = ["selectedIds", "bulkButton", "counter", "bedCheckbox", "bulkForm"];
  
  declare readonly selectedIdsTarget: HTMLInputElement;
  declare readonly bulkButtonTarget: HTMLButtonElement;
  declare readonly counterTarget: HTMLElement;
  declare readonly bedCheckboxTargets: HTMLInputElement[];
  declare readonly bulkFormTarget: HTMLFormElement;

  connect() {
    this.updateUI();
  }

  toggleAll(event: Event) {
    const masterCheckbox = event.target as HTMLInputElement;
    
    this.bedCheckboxTargets.forEach(checkbox => {
      checkbox.checked = masterCheckbox.checked;
    });
    
    this.updateSelection();
  }

  toggleBed() {
    this.updateSelection();
    this.updateMasterCheckbox();
  }

  private updateSelection() {
    const selectedIds = this.getSelectedBedIds();
    this.selectedIdsTarget.value = selectedIds.join(',');
    this.updateUI();
  }

  private updateMasterCheckbox() {
    const masterCheckbox = this.element.querySelector('input[type="checkbox"][data-action*="toggleAll"]') as HTMLInputElement;
    
    if (!masterCheckbox) return;

    const totalBeds = this.bedCheckboxTargets.length;
    const selectedBeds = this.getSelectedBedIds().length;

    if (selectedBeds === 0) {
      masterCheckbox.checked = false;
      masterCheckbox.indeterminate = false;
    } else if (selectedBeds === totalBeds) {
      masterCheckbox.checked = true;
      masterCheckbox.indeterminate = false;
    } else {
      masterCheckbox.checked = false;
      masterCheckbox.indeterminate = true;
    }
  }

  private updateUI() {
    const selectedIds = this.getSelectedBedIds();
    const count = selectedIds.length;
    
    // Update counter text
    this.counterTarget.textContent = i18n.t('bed_bulk_actions.beds_selected', { count });
    
    // Enable/disable bulk action button
    this.bulkButtonTarget.disabled = count === 0;
  }

  private getSelectedBedIds(): string[] {
    return this.bedCheckboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value);
  }
}